import { render, staticRenderFns } from "./savejobWidget.vue?vue&type=template&id=d2acb436"
import script from "./savejobWidget.vue?vue&type=script&lang=js"
export * from "./savejobWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports